module.exports = __webpack_public_path__ + "media/images/velo-tandem-4ac2010079889ca27018fc2321177595.png";